<template>
  <div>
    <img v-if="pc" :src="$t('company.img')" width="100%" />
    <img v-else :src="$t('company.imgm')" width="100%" />
    <div v-if="!pc" style="position: fixed;z-index: 9">
      <div v-show="!mf" style="margin-left: -5px;color: #7f1f20;font-size: 30px" @click="mf = !mf">
        <a-icon type="caret-right" />
      </div>
      <div v-show="mf" style="margin-left: -20px">
        <div class="navigation_m" style="width: 220px">
          <div @click="mf = !mf" style="font-size: 30px">
            <a-icon type="caret-left" />
          </div>
          <div :class="{active_m : name === 'companyProfile'}" @click="query('companyProfile')">
            <span>{{$t('company.companyProfile.name')}}</span>
          </div>
          <div :class="{active_m : name === 'professionals'}" @click="query('professionals')">
            <span>{{$t('company.professionals.name')}}</span>
          </div>
          <div :class="{active_m : name === 'careers'}" @click="query('careers')">
            <span>{{$t('company.careers.name')}}</span>
          </div>
          <div :class="{active_m : name === 'story'}" @click="query('story')">
            <span>{{$t('company.story.name')}}</span>
          </div>
          <div :class="{active_m : name === 'contactUs'}" @click="query('contactUs')">
            <span>{{$t('company.contactUs.name')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mw1200" :class="{mlr: !pc}" style="margin: 60px auto">
      <div class="h1_p">
        <h1 :class="{f36: !pc}">{{$t('menu.company')}}</h1>
        <p :class="{f20: !pc}" :style="{lineHeight: pc?'1.2':'26px'}" v-html="pc ? $t('company.p') : $t('company.p').replace(/&lt;br>/, '')"></p>
      </div>
      <a-affix v-if="pc" :offset="50">
        <div class="navigation">
          <div :class="{active : name === 'companyProfile'}" @click="query('companyProfile')">
            <span>{{$t('company.companyProfile.name')}}</span>
          </div>
          <div :class="{active : name === 'professionals'}" @click="query('professionals')">
            <span>{{$t('company.professionals.name')}}</span>
          </div>
          <div :class="{active : name === 'careers'}" @click="query('careers')">
            <span>{{$t('company.careers.name')}}</span>
          </div>
          <div :class="{active : name === 'story'}" @click="query('story')">
            <span>{{$t('company.story.name')}}</span>
          </div>
          <div :class="{active : name === 'contactUs'}" @click="query('contactUs')">
            <span>{{$t('company.contactUs.name')}}</span>
          </div>
        </div>
        <img src="@/assets/top.png" alt="top" style="margin-left: 125px;cursor: pointer;position: absolute;margin-top: 400px;" @click="toTop" />
      </a-affix>
      <div :style="{margin: pc?'50px 0 150px 235px':'30px 0 150px 0'}">
        <div v-show="name === 'companyProfile'">
          <div :style="{fontSize: pc?'24px':'30px'}" style="color: #7F1F20;margin-bottom: 10px">{{ $t('company.companyProfile.name') }}</div>
          <div :style="{width: pc?'75%':'100%', fontSize: pc?'15px':'20px', lineHeight: pc?'23px':'30px'}" style="min-height: 300px" v-html="$t('company.companyProfile.p')"></div>
        </div>
        <div v-show="name === 'professionals'">
          <div :style="{fontSize: pc?'24px':'30px'}" style="color: #7F1F20">{{ $t('company.professionals.h1') }}</div>
          <div :style="{fontSize: pc?'18px':'20px', lineHeight: pc?'23px':'1.2'}" style="font-family: MonotypeCorsiva,楷体, Arial, serif;margin-bottom: 20px;color: #595959" v-html="$t('company.professionals.p').replace(/&lt;br>/, '')"></div>
          <a-tabs v-if="pc" v-model="defaultActiveKey" :tabBarGutter="55">
            <a-tab-pane v-for="(item, index) in $t('company.professionals.people')" :tab="item" :key="index">
              <div v-for="i in Math.ceil(list.length/3)" :key="i" style="border-bottom: 1px #c2c2c2 solid">
                <div style="display: flex;justify-content: space-between;flex-wrap: wrap">
                  <div v-for="j in 3" :key="j" style="width: 33%">
                    <div v-if="(i-1)*3 + j - 1 < list.length" style="display: flex;margin: 30px 0 20px 0">
                      <img :src="`/acnImg/people/${list[(i-1)*3 + j-1].ename}.png`"
                           width="105"
                           height="105"
                           style="border-radius: 50%;flex-shrink: 0;cursor: pointer"
                           @click="vm(list[(i-1)*3 + j-1])"
                      >
                      <div style="padding: 40px 0 0 10px;width: 100%">
                        <div style="font-size: 16px;color: #7F1F20">
                          {{isEn ? list[(i-1)*3 + j-1].ename : list[(i-1)*3 + j-1].cname}}
                        </div>
                        <div v-html="isEn ?
                      list[(i-1)*3 + j-1].etitle1 + '<br>' + list[(i-1)*3 + j-1].etitle2 :
                      list[(i-1)*3 + j-1].ctitle1 + '<br>' + list[(i-1)*3 + j-1].ctitle2"
                             style="font-style: italic;overflow: hidden;
                           display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;
                           margin-bottom: 5px;line-height: 1.3"></div>
                        <span @click="vm(list[(i-1)*3 + j-1])"
                              style="color: #b2b2b2;cursor: pointer;border-bottom: 1px #b2b2b2 solid">{{isEn?'View personal Profile':'查阅个人简历'}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
          <template v-else>
            <div v-for="(item, index) in $t('company.professionals.people')" :key="index">
              <div style="font-size: 26px;color: #7f1f20;border-bottom: 1px black solid;margin-bottom: 30px">{{item}}</div>
              <div style="display: flex;justify-content: space-between;flex-wrap: wrap">
              <div v-for="item in index===0?all.filter(p => p.sales === 1):
                                 (index===1?all.filter(p => p.regionalRep === 1):all.filter(p => p.advisory === 1))"
                   :key="item.id"
                   style="border-bottom: 1px #c2c2c2 solid;width: 50%;display: flex;padding-bottom: 20px;margin-bottom: 30px">
                <img :src="`/acnImg/people/${item.ename}.png`"
                     width="105"
                     height="105"
                     style="border-radius: 50%;flex-shrink: 0;cursor: pointer"
                     @click="vm(item)"
                >
                <div style="padding: 40px 0 0 10px">
                  <div style="font-size: 20px;color: #7F1F20">
                    {{isEn ? item.ename : item.cname}}
                  </div>
                  <div :class="{f16: !pc}" v-html="isEn ?
                      item.etitle1 + '<br>' + item.etitle2 :
                      item.ctitle1 + '<br>' + item.ctitle2"
                       style="font-style: italic;overflow: hidden;
                           display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;
                           margin-bottom: 5px;line-height: 1.3"></div>
                  <span @click="vm(item)"
                        style="color: #b2b2b2;cursor: pointer;border-bottom: 1px #b2b2b2 solid">{{isEn?'View personal Profile':'查阅个人简历'}}</span>
                </div>
              </div>
              </div>
            </div>
          </template>
        </div>
        <div v-show="name === 'careers'">
          <div :style="{fontSize: pc?'24px':'30px'}" style="color: #7F1F20">{{ $t('company.careers.name') }}</div>
          <div :style="{fontSize: pc?'18px':'20px', lineHeight: pc?'23px':'30px'}" style="color: #595959;font-family: MonotypeCorsiva,楷体, Arial, serif" v-html="$t('company.careers.p')"></div>
          <div style="display: flex;flex-wrap: wrap;justify-content: space-between;margin-top: 30px">
            <div v-for="(item, index) in $t('company.careers.list')" :key="index"
                 :style="{width: pc?'48%':'100%'}"
                 style="background: url('/acnImg/company/careers_bg.png') 0 0 / cover no-repeat;padding: 35px 40px 30px 0;margin-bottom: 30px">
              <div :style="{fontSize: pc?'20px':'26px'}" style="font-size: 20px;color: #00023d;padding-left: 45px;background: url('/acnImg/company/ju.png') no-repeat 0 center;margin-bottom: 10px">
                {{item.title}}</div>
              <div :style="{fontSize: pc?'15px':'20px', lineHeight: pc?'23px':'30px'}" style="color:#595959;padding-left: 45px">{{item.p}}</div>
            </div>
          </div>
        </div>
        <div v-show="name === 'story'">
          <div :style="{fontSize: pc?'24px':'30px'}" style="color: #7F1F20;margin-bottom: 10px">{{ $t('company.story.name') }}</div>
          <div style="display: flex;justify-content: space-between">
            <div :style="{fontSize: pc?'15px':'20px', width: pc?'62%':'100%', lineHeight: pc?'23px':'30px'}" v-html="$t('company.story.p')"></div>
            <div v-if="pc" style="width: 32%">
              <img src="/acnImg/company/story.jpg" width="100%" />
            </div>
          </div>
        </div>
        <div v-show="name === 'contactUs'">
          <div :style="{fontSize: pc?'24px':'30px', marginBottom: pc?'0':'20px'}" style="color: #7F1F20">{{ $t('company.contactUs.name') }}</div>
          <iframe :src="mapSrc" frameborder="0" width="100%" height="500px"></iframe>
          <div v-if="pc" style="display: flex;justify-content: space-between;margin-top: 40px">
            <div style="width: 58%">
              <a-input :placeholder="$t('company.contactUs.i1')" style="margin-bottom: 20px"></a-input>
              <a-input :placeholder="$t('company.contactUs.i3')" style="margin-bottom: 20px"></a-input>
              <a-input :placeholder="$t('company.contactUs.i2')" style="margin-bottom: 20px"></a-input>
              <a-textarea :placeholder="$t('company.contactUs.i4')" style="margin-bottom: 20px;height: 140px"></a-textarea>
              <a-button class="b_c_u" style="margin-top: 30px;width: 65px">{{isEn?'Send':'发送'}}</a-button>
            </div>
            <div style="width: 35%;">
              <div style="color: #595959;margin-top: 155px">
                <div style="font-size: 18px;margin-bottom: 5px">{{ $t('company.contactUs.a1') }}</div>
                <div v-html="$t('company.contactUs.a2')" style="font-size: 15px;line-height: 23px;"></div>
              </div>
            </div>
          </div>
          <div v-else>
            <div style="color: #595959;margin-top: 20px">
              <div style="font-size: 26px;margin-bottom: 5px">{{ $t('company.contactUs.a1') }}</div>
              <div v-html="$t('company.contactUs.a2')" style="font-size: 20px;line-height: 1.4;margin-bottom: 50px"></div>
            </div>
            <a-input :placeholder="$t('company.contactUs.i1')" style="margin-bottom: 20px" size="large"></a-input>
            <a-input :placeholder="$t('company.contactUs.i3')" style="margin-bottom: 20px" size="large"></a-input>
            <a-input :placeholder="$t('company.contactUs.i2')" style="margin-bottom: 20px" size="large"></a-input>
            <a-textarea :placeholder="$t('company.contactUs.i4')" style="margin-bottom: 20px;height: 140px" size="large"></a-textarea>
            <a-button class="b_c_u" style="margin-top: 30px;width: 80px;font-size: 20px">{{isEn?'Send':'发送'}}</a-button>
          </div>
        </div>
      </div>
      <a-modal v-if="people.id" destroyOnClose v-model="visible" centered :footer="null" :bodyStyle="{padding: 0}" :maskStyle="{background: 'rgba(0,0,0,0.85)'}" :width="pc?1000:'90%'">
        <div style="padding: 70px 50px">
          <div style="display: flex;margin-bottom: 30px;">
            <img :src="`/acnImg/people/${people.ename}.png`" width="105" height="105" style="border-radius: 50%" />
            <div style="margin: 40px 0 0 15px">
              <div :style="{fontSize: pc?'20px':'26px'}"  style="color: #7F1F20">
                {{isEn ? people.ename : people.cname}}
              </div>
              <div :class="{f20: !pc}" :style="{lineHeight: pc?'18px':'23px'}" style="font-style: italic;margin-bottom: 10px" v-html="isEn ? people.etitle1 + '<br>' + people.etitle2 : people.ctitle1 + '<br>' + people.ctitle2"></div>
              <div :class="{f20: !pc}" :style="{lineHeight: pc?'18px':'23px'}">
                <span style="font-weight: bold">{{isEn ? 'Nationality' : '国籍'}}: </span>{{isEn ? people.enationality : people.cnationality}}
              </div>
              <div :class="{f20: !pc}" :style="{lineHeight: pc?'18px':'23px'}">
                <span style="font-weight: bold">{{isEn ? 'Language(s)' : '语言'}}: </span>{{isEn ? people.elang : people.clang}}
              </div>
              <div :class="{f20: !pc}" :style="{lineHeight: pc?'18px':'23px'}">
                <span style="font-weight: bold">Email: </span>{{people.email}}
              </div>
            </div>
          </div>
          <div :class="{f20: !pc}" v-html="isEn ? people.ebio : people.cbio"
               :style="{lineHeight: pc?'23px':'30px'}"
               style="color: #404040;font-size: 15px"></div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
export default {
  name: 'Company',
  data () {
    return {
      name: 'companyProfile',
      all: [],
      visible: false,
      people: {},
      defaultActiveKey: 0,
      mf: false
    }
  },
  computed: {
    ...mapGetters(['isEn', 'pc']),
    list () {
      if (this.defaultActiveKey === 0) {
        return this.all.filter(p => p.sales === 1)
      } else if (this.defaultActiveKey === 1) {
        return this.all.filter(p => p.regionalRep === 1)
      } else if (this.defaultActiveKey === 2) {
        return this.all.filter(p => p.advisory === 1)
      } else {
        return []
      }
    },
    mapSrc () {
      return this.isEn ? 'map/map_en.html' : 'map/map_cs.html'
    }
  },
  methods: {
    vm (i) {
      this.people = i
      this.visible = true
    },
    query (name) {
      this.name = name
      this.mf = false
    },
    toTop () {
      window.scrollTo(0, 0)
    }
  },
  mounted () {
    request.get('/people/list').then(res => {
      this.all = res
    })
    if (this.$route.params.name === 'professionals') {
      this.name = 'professionals'
      this.defaultActiveKey = Number(this.$route.params.tab)
    } else if (this.$route.params.name === 'contactUs') {
      this.name = 'contactUs'
    }
  }
}
</script>

<style lang="less">
  .ant-tabs-tab {
    font-size: 18px;
    padding: 3px 0 !important;
  }
  .ant-modal-close-x {
    font-size: 50px;
    margin: 30px;
  }
  .b_c_u:hover {
    background: #404040;
    color: #D9D9D9;
    border: none;
  }

  .ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane, .ant-tabs .ant-tabs-bottom-content > .ant-tabs-tabpane {
    -webkit-backface-visibility: hidden;
  }
</style>
